export const flattenObject = <T = object>(objectToFlatten: { [key: string]: object }): T =>
	Object.values(objectToFlatten).reduce((acc, cur) => ({ ...acc, ...cur }), {} as T);
